<template>
    <div>
        <section v-if="paso1" class="padding-vertical-content white-content right-background">
            <div class="thumb-container absolute grayscale light-thumb" :style='"background-image: url(" + manager.bg2_url + ")"'></div>
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <div class="row justify-content-start">
                            <div class="col-12 col-lg-6 col-xl-5">
                                <h2 class="m-0 mt-5 h1 text-uppercase">{{ $t('renovar_abono.renueva_abono', {abono: teatro.texto_abono}) }}</h2>
                                <div class="subtitle h3 light mb-3 mb-lg-5"> {{ $t('renovar_abono.temporada', { temporada: lista_abonados.nombre }) }}</div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-lg-6 col-xl-5">
                        <BuscarAbonadoLfp
                            @terminado="abonadoEncontrado"
                        ></BuscarAbonadoLfp>
                    </div>
                </div>
            </div>
        </section>

        <transition name="fade" mode="out-in">
            <section class="padding-vertical-content white-content mb-3 mb-lg-4" v-if="envio" key="envio" id="envio">
                <div class="container">
                    <div class="row">
                        <EnviosComponent
                            :datos_compradores="[abonado, []]"
                            @envioSolicitado="envioSolicitado"
                            @continuarSinEnvio="continuarSinEnvio"
                        />
                    </div>
                </div>
            </section>
        </transition>

        <transition name="fade" mode="out-in">
            <section class="padding-vertical-content white-content mb-3 mb-lg-4" v-if="paso2" key="paso2" id="paso2">
                <div class="container">
                    <div class="row">
                        <div class="col-12">
                            <div class="padding-content white-content mb-4">                            
                                <PersonaInfoForm 
                                    :data="abonado"
                                />
                            </div>    
                        </div>
                        <div class="col-12 col-lg-8">
                            <table class="table tabla-resumen table-bordered mb-4 mb-lg-5">
                                <tr class="lightgray-content">
                                    <th></th>
                                    <th>{{ $t('general.abono', {abono: teatro.texto_abono}) }}</th>
                                    <th v-if="abonado.gastos_envio">{{ $t('general.gastos_envio') }}</th>  
                                    <th class="price">{{ $t('general.precio') }}</th>
                                </tr>

                                <tr>
                                    <td class="h1 text-center regular">Abono</td>
                                    <td>
                                        <strong class="text-bold h5 d-block mb-1">Tipo abono</strong>
                                        <template>
                                            <strong class="text-bold h7 d-block mb-1">{{ abonado.titulo.NombreZona }}</strong>
                                            <strong class="text-bold h7 d-block mb-1"> {{ $t('general.fila') }}: {{ abonado.titulo.Fila }} - {{ $t('general.butaca') }}: {{ abonado.titulo.Asiento }}</strong>
                                        </template>                          
                                    </td>
                                    <td v-if="abonado.gastos_envio"></td>
                                    <td>
                                        <div class="h3 m-0">{{ abonado.total_price | formatear_precio }}</div>
                                    </td>
                                </tr>
                                <tr>
                                    <td colspan="2"></td>
                                    <td v-if="abonado.gastos_envio"><span class="total-price h2 m-0">{{ abonado.gastos_envio | formatear_precio }}</span></td>
                                    <td>
                                        <span class="total-price h2 m-0">{{ precio_total | formatear_precio }}<small v-if="! abonado.gastos_internos">*</small></span>
                                    </td>
                                </tr>
                            </table>
                            
                            <div class="col-12 col-lg-8 mt-4">
                                <FormTerminos 
                                    :error="error"
                                    @continuar="aceptarCondiciones"
                                />
                            </div>
                            <p class="mb-2 mb-md-4">
                                <small v-if="! abonado.gastos_internos">
                                    * {{ $t('general.el_precio', { precio: $options.filters.formatear_precio(precio_total - abonado.gastos), gastos: $options.filters.formatear_precio(abonado.gastos), iva: 21, moneda: '€' }) }}
                                </small>
                            </p>
                            <button id="terminar-compra" class="button large-button effect-button" @click.prevent="terminar"><span>{{ $t('nuevo_abono.continuar') }}</span></button>
                            <template v-if="abonado.formulario_compra != null" >
                                <div id="formulario-compra" v-html="abonado.formulario_compra" v-show="false"></div>
                            </template>
                        </div>
                    </div>
                </div>
            </section>
        </transition>
    </div>
</template>

<script>
import BuscarAbonadoLfp from '@/components/frontend/abonos/renovar/components/BuscarAbonadoLfp';
import PersonaInfoForm from '@/components/frontend/abonos/renovar/components/PersonaInfoForm';
import FormTerminos from '@/components/frontend/components/FormTerminos';
import EnviosComponent from '../nuevo/EnviosComponent.vue';

export default {
    data() {
        return {
            paso1: true,
            paso2: false,
            paso3: false,
            envio: false,
            loading: false,
            abonado: null,
            terminos: false,
            error: false
        }
    },
    computed: {
        manager() {
            return this.$store.getters.getFooter;
        },
        configuracion() {
            return this.$store.getters.getConfig;
        },
        lista_abonados() {
            return this.$store.getters.getListaAbonados;
        },
        teatro(){
            return this.$store.getters.getTeatro
        },
        precio_total() {
            let precio = this.abonado.total_price;

            if(this.abonado.gastos_envio) {
                precio += this.abonado.gastos_envio;
            }

            return precio;
        }
    },
    methods: {
        abonadoEncontrado(abonado) {
            this.abonado = abonado;

            if(this.lista_abonados.permitir_envio_a_domicilio) {
                this.paso1 = false;
                this.envio = true;
            } else {
                this.paso1 = false;
                this.paso2 = true;
            }
            
            
        },
        terminar() {
            this.loading = true;
            if(this.terminos) {
                setTimeout(() => {
                    document.getElementById('btn-pagar').click();
                }, 500);
            } else {
                this.loading = false;
                this.error = true;
            }                
        },
        aceptarCondiciones(continuar) {
            if (continuar == true) {
                this.terminos = true;
            } else {
                this.terminos = false;
            }
        },
        envioSolicitado(datos_envio) {
            const params = {
                filters: {},
                tid: this.configuracion.hash_teatro,
                session_id: this.abonado.session_id,
                datos_envio: datos_envio
            }

            this.$store.dispatch(this.config.getVuexAlias('lfp.abono.solicitar.envio'), params).then(res => {
                this.abonado.formulario_compra = res.data.formulario_compra;
                this.abonado.gastos_envio = res.data.gastos_envio;
                this.envio = false;
                this.paso2 = true;
            });
        },
        continuarSinEnvio() {
            this.envio = false;
            this.paso2 = true;
        }
    },
    components: {
        BuscarAbonadoLfp, PersonaInfoForm, FormTerminos, EnviosComponent
    }
}
</script>